<template>
    <div class="w-1200" style="padding-bottom: 100px;">
        <div :class="headerStyle?'font-28 mt-8':'font-24 font-500 mt-8'">{{productName}}</div>
        <div class="mt-8" style="width: 1200px;height: 10px;background: #F7F9FA;"></div>
        <div v-for="(item,index) in productList" :key="item.id"
             class="item font-16" v-if="item.data.length">
            <div class="flex itemHeader mt-8">
                <div class="first font-20 font-600 color-red">{{item.name}}</div>
                <div v-if="index === 0">Name</div>
                <div v-if="index === 0">Number</div>
                <div v-if="index === 0">Category</div>
                <div v-if="index === 0">Platform</div>
                <div v-if="index === 0 && recommendShow">Use</div>
                <div v-if="index === 0">Introduction</div>
            </div>
            <div class="flex itemBody mt-4">
                <div class="first">{{item.desc}}</div>
                <div>
                    <div class="category flex" v-for="s in item.data" :key="s.id">
                        <div>{{s.name}}</div>
                        <div>{{s.field1}}</div>
                        <div>{{s.field2}}</div>
                        <div>{{s.field3}}</div>
                        <div v-if="recommendShow">{{s.field4}}</div>
                        <div :style="'opacity:'+(s.file_url?1:0)+';'" @click="$fn.toPage(s.file_url)"
                             class="color-red 1">Introduction
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'productList',
        props: {
            productList: {
                default: [{}]
            },
            headerStyle: {
                default: false
            },
            productName: {
                type: String
            },
            recommendShow: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {}
        },
        async mounted() {

        },
        methods: {},

    }
</script>
<style scoped lang="scss">
    .item {
        .first {
            flex: 1 0 300px !important;
            padding-right: 50px;
            box-sizing: content-box;
        }

        .itemHeader {
            height: 44px;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                width: 1200px;
                height: 1px;
                background: #BD2C2E;
                border-radius: 1px;
            }

            & > div:last-child {
                padding-right: 0;
            }

            & > div {
                padding-right: 50px;
                width: 100px;
                flex: 1 0 100px;
                box-sizing: content-box;
            }
        }

        .itemBody {
            & > div {
                flex: 1 1 800px;

                .category {
                    margin-bottom: 15px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    & > div:last-child {
                        padding-right: 0;
                    }

                    & > div {
                        padding-right: 50px;
                        flex: 1 0 100px;
                        width: 100px;
                        box-sizing: content-box;
                    }
                }
            }

        }
    }
</style>
